class productPairsRight extends HTMLElement {
    constructor() {
      super();
      this.fetchData();
    }
    fetchData() {
      if(!this.dataset.url) {
        this.initSlick();
        return;
      }
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
      }).
      then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const content = html.querySelector(".product-pairsright");
        this.innerHTML = content.innerHTML;
        this.initSlick();
      }).catch((error) => {
        console.error("Error fetching product recommendations:", error);
      });
    }
  
    initSlick() {
      $('.product-pairsright').addClass('product-pairsright--loaded');
      $('.product-pairs-list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false
      });
    }
  }
  
  customElements.define('product-pairsright', productPairsRight);
  
  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }
  
    connectedCallback() {
      this.checkAgreement();
    }
  
    handleClick(event) {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      const checkoutButton = this.querySelector('.product-form__buynow');
      
      if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
        if (agreeCheckbox.checked) {
          checkoutButton.classList.remove('disabled');
        } else {
          checkoutButton.classList.add('disabled');
        }
      }
    }
    checkAgreement() {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      return agreeCheckbox.checked;
    }
  }
  
  customElements.define('buy-now', BuyNow);